import { Card } from '@/components/ui/card';

type ChatAvailabilityBannerProps = {
  remaining: number;
  warningThreshold: number;
};

export const ChatAvailabilityBanner = ({
  remaining,
  warningThreshold,
}: ChatAvailabilityBannerProps) => {
  if (remaining > warningThreshold) {
    return null;
  }

  const isBlocked = remaining <= 0;

  const message = isBlocked
    ? 'Hai raggiunto il limite giornaliero di messaggi. Riprova domani.'
    : `Ti restano ${Math.max(remaining, 0)} messaggi disponibili oggi. Prenditi una pausa.`;

  return (
    <Card
      variant="flat"
      semantic={isBlocked ? 'destructive' : 'warning'}
      className="gap-2 px-3 py-2"
    >
      <p className={isBlocked ? 'text-destructive' : undefined}>{message}</p>
    </Card>
  );
};
